type ServerErrorMessageMapping = {
  pattern: RegExp;
  message: string;
};

const serverErrorMessageMappings: ServerErrorMessageMapping[] = [
  {
    pattern:
      /Sign-in blocked: your Security Auditor membership overlaps with another functional group/,
    message:
      'Вход запрещён: группа Security Auditor пересекается с другой функциональной группой. Удалите конфликтующее членство и повторите вход после синхронизации каталога.',
  },
  {
    pattern: /Sign-in blocked: your Catalog User is not available yet/,
    message:
      'Вход пока недоступен: пользователь не найден в каталоге. Проверьте свою учётную запись и повторите вход после синхронизации каталога.',
  },
  {
    pattern: /Sign-in blocked: your Catalog memberships could not be resolved/,
    message:
      'Вход пока недоступен: не удалось определить членство пользователя в группах каталога. Проверьте свою учётную запись и повторите вход после синхронизации каталога.',
  },
  {
    pattern:
      /Authentication failed, did not find expected authorization request details in session/,
    message:
      'Не удалось завершить вход: данные запроса авторизации не найдены в сессии. Повторите вход.',
  },
];

export function translateServerErrorMessage(message: string): string {
  return (
    serverErrorMessageMappings.find(mapping => mapping.pattern.test(message))
      ?.message ?? message
  );
}
